export const URL_EDGES_NODE_DATA = '/edges/node-data/:project_id/:edge_type_id';
export const URL_CREATE_EDGE = '/edges/create';
export const URL_UPDATE_EDGE = '/edges/update/:id';
export const URL_DELETE_EDGE = '/edges/delete/:id';
